<template>
  <li v-if="user.company" class="rent-pre-registrations-menu dropdown" :class="{ 'active': routeName == 'orders_list'}">
    <audio ref="newRents" :src="cdn('sound.mp3')"></audio>
    <audio ref="newRentSound" :src="cdn('beep.mp3')"></audio>
    <router-link :to="{name: 'orders_list'}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      Display<span v-if="countOrders > 0" class="bell-badge">{{ countOrders }}</span>
    </router-link>
  </li>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'RentPreRegistrationsMenu',
    components: {},
    data () {
      return {
        interval: false
      }
    },
    computed: {
      routeName () {
        return this.$route.name || ''
      },
      ...mapState({
        countOrders: state => state.orders,
        user: state => state.user
      })
    },
    mounted () {
      this.setOrders(this.countOrders)
      this.getRentsPreRegistrations()
      this.listenEvents()
      this.interval = setInterval(this.playAlertSound, 5 * 60000)
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {
      playAlertSound () {
        if (this.countOrders > 0) {
          // this.$refs.newRents.play()
        }
      },
      setOrders (orders) {
        if (orders > this.countOrders) {
          setTimeout(() => {
            // this.$refs.newRentSound.play()
          }, 1)
        }
        this.changeOrders(orders)
      },
      getRentsPreRegistrations () {
        this.loading = true
        this.loadRentPreRegistrationsCount({companyId: this.user.company.id})
        .then((response) => {
          this.setOrders(response.data)
          this.loading = false
        }, (error) => {
          console.log(error)
          this.loading = false
        })
      },
      listenEvents () {
        window.Channel.listen('.App\\Events\\RentPreRegistrationCompanyAttend', (e) => {
          this.setOrders(e.count)
        })
      },
      ...mapActions([
        'loadRentPreRegistrationsCount',
        'changeOrders'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// RentPreRegistrationsMenu.vue?b839fc3e